<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
        v-for="breadcrumb in breadcrumbs"
        :key="breadcrumb.name"
        :disabled="typeof breadcrumb.link === 'undefined'"
        :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-form ref="form" validation @input="checkValidate" class="ml-3">
      <v-layout row>
        <v-flex xs12 lg12 md12>
          <h1 class="my-3">{{title}}</h1>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
            label="Наименование"
            v-model="productStockSettingTitle"
            :rules="productStockSettingTitleRules"
            validate-on-blur
            outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row class="mb-3">
        <v-flex xs12 lg8 md8>
          <v-layout row>
            <v-flex xs12 lg12 md12 class="case-branches">
              <v-combobox
                :items="[]"
                v-model="branchesSelected"
                label="Филиалы"
                chips
                outline
                multiple
                readonly
                @click="branchesDialog = true"
              >
                <template slot="selection" slot-scope="data">
                  <v-chip
                    @click="branchesDialog = true"
                  >
                    <strong>{{ data.item }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <p class="title">Список SKU</p>
      <v-layout>
        <v-flex xs6 lg6 md6>
          <v-card class="elevation-1 py-3">
            <v-card-text class="text-lg-left py-0" v-for="(product, index) in productList" :key="index">{{product.title}}</v-card-text>
            <v-btn
              color="primary mt-3 ml-3"
              @click="productsDialog = true"
            >
              Выбрать SKU
            </v-btn>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 mt-3">
        <v-flex xs12 lg6 md6>
          <v-btn
            :loading="loading"
            :disabled="!valid || loading"
            color="primary"
            @click.native="loader = 'loading'"
            class="ma-0"
            @click="onClickCreateProductStockSetting"
          >
            {{id === null ? 'Создать' : 'Изменить'}}
          </v-btn>
        </v-flex>
      </v-layout>

      <v-dialog
        v-model="branchesDialog"
        max-width="600"
      >
        <v-card>
          <v-card-title class="headline">Филиалы</v-card-title>
          <v-layout row>
            <v-flex xs12 lg12 md12 class="ml-2">
              <div
                v-for="(branch, index) in branches"
                :key="branch.id"
              >
                <v-checkbox
                  :label="branch.title"
                  class="ma-0 pa-0"
                  v-model="branches[index].checked"
                  @change="onBranchInput"
                ></v-checkbox>
              </div>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="branchesDialog = false">ОК</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="productsDialog"
        max-width="600"
      >
        <v-card>
          <v-card-title class="headline">Товары</v-card-title>
          <v-layout row>
            <v-flex xs12 lg12 md12 class="ml-2">
              <v-progress-circular
                v-if="productLoading"
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <div v-if="productTreeData.length > 0 && !productLoading">
                <tree
                  :data="productTreeData"
                  :options="{
                checkbox: true,
                  fetchData(node) {
                    if (node.data.type === 'category') {
                      return getProductBrand(node.data.id)
                    } else if (node.data.type === 'brand') {
                      return getProductSku(node.data.id)
                    }
                  }
                }"
                  class="tree--small case-dialog-tree"
                  @node:checked="onProductSkuChecked"
                  @node:unchecked="onProductSkuUnchecked"
                />
              </div>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="productsDialog = false">ОК</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Скрытие остатков', link: '/restrictions/active'}
      ],
      pageDataReady: {
        isReady: false,
        products: false,
        branchList: false
      },
      branches: [],
      branchesSelected: [],
      branchesDialog: false,
      productListTreeData: [],
      productList: [],
      productTreeData: [],
      productTreeIdCounter: 0,
      productLoading: false,
      productsDialog: false,
      id: null,
      title: 'Новое ограничение',
      productStockSettingTitle: null,
      valid: false,
      productStockSettingTitleRules: [
        v => !!v || 'Обязательное поле'
      ]
    }),
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.products) {
          return false
        }
        if (!this.pageDataReady.branchList) {
          return false
        }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onProductSkuChecked (node) {
        let position = this.productList.findIndex(item => {
          return item.id === node.data.id
        })

        if (node.data.type === 'sku' && !~position) {
          this.productList.push({
            id: node.data.id,
            title: node.text,
            unit: node.data.unit,
            weight: node.data.weight
          })
        }
      },
      onProductSkuUnchecked (node) {
        if (node.data.type === 'sku') {
          let position = this.productList.findIndex(item => {
            return item.id === node.data.id
          })

          if (~position) {
            this.productList.splice(position, 1)
          }
        }
      },
      onBranchInput () {
        this.branchesSelected = []
        for (let i = 0; i < this.branches.length; i++) {
          if (this.branches[i].checked) {
            this.branchesSelected.push(this.branches[i].title)
          }
        }
      },
      async onClickCreateProductStockSetting () {
        let productStockSettingData = {
          id: this.id,
          title: this.productStockSettingTitle
        }

        let branchIdList = []
        for (let i = 0; i < this.branches.length; i++) {
          if (this.branches[i].checked) {
            branchIdList.push(this.branches[i].id)
          }
        }
        if (branchIdList.length > 0) {
          productStockSettingData.branchIdList = branchIdList
        }

        productStockSettingData.productIdList = this.productList.map(item => {
          return item.id
        })

        await this.$store.dispatch('createProductStockSetting', productStockSettingData)
          .then((data) => {
            if (typeof data.product_stock_setting !== 'undefined') {
              this.$router.push('/product/stock/setting/single/' + data.product_stock_setting.id)
            }
          })
          .catch((e) => {
            console.log(e)
          })
      },
      checkValidate () {
        this.valid = !(this.productStockSettingTitle === null || this.productStockSettingTitle === '')
        return this.valid
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)

        this.id = null
        this.branches = []
        this.branchIdList = []
        this.productStockSettingTitle = null
        this.productListTreeData = []
        this.productList = []
        this.productTreeData = []
        this.productTreeIdCounter = 0

        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Скрытие остатков', link: '/product/stock/setting/active'}
        ]

        if (this.$router.currentRoute.path.indexOf('/product/stock/setting/edit/') !== -1) {
          this.id = parseInt(this.$route.params.id)
          this.title = 'Редактировать скрытый остаток'
          this.breadcrumbs.push({name: 'Редактировать скрытый остаток'})
          this.$store.dispatch('getBranchList')
            .then(() => {
              this.pageDataReady.branchList = true
              this.pageDataStatus()
              this.$store.dispatch('getProductStockSettingSingle', {id: this.id})
            })
        } else {
          this.id = null
          this.title = 'Новый скрытый остаток'
          this.breadcrumbs.push({name: 'Новый скрытый остаток'})

          this.$store.dispatch('getBranchList')
            .then(() => {
              this.pageDataReady.branchList = true
              this.pageDataStatus()
            })

          this.getProductCategory()
            .then((data) => {
              this.productTreeData = data
              this.pageDataReady.products = true
              this.pageDataStatus()
            })
            .catch(() => {})
        }
        this.$store.commit('setPageTitle', this.title)
      },
      async getProductCategory () {
        let categoryList = []
        await this.$store.dispatch('getProductCategoryList')
          .then((data) => {
            for (let i = 0; i < data.product_category_list.length; i++) {
              categoryList[i] = {
                text: data.product_category_list[i].title,
                data: {
                  id: data.product_category_list[i].id,
                  type: 'category'
                },
                id: this.productTreeIdCounter++,
                isBatch: true
              }
              categoryList[i].state = { checkbox: false }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return categoryList
      },
      async getProductBrand (categoryId) {
        let brandList = []
        await this.$store.dispatch('getProductBrandList', {id: categoryId})
          .then((data) => {
            for (let i = 0; i < data.product_category_brand_list.length; i++) {
              brandList[i] = {
                text: data.product_category_brand_list[i].title,
                data: {
                  id: data.product_category_brand_list[i].id,
                  productBrandId: data.product_category_brand_list[i].product_brand_id,
                  type: 'brand'
                },
                id: this.productTreeIdCounter++,
                isBatch: true
              }
              brandList[i].state = { checkbox: false }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return brandList
      },
      async getProductSku (brandId) {
        let skuList = []
        await this.$store.dispatch('getProductSkuList', {id: brandId})
          .then((data) => {
            for (let i = 0; i < data.product_sku_list.length; i++) {
              skuList[i] = {
                text: data.product_sku_list[i].title,
                data: {
                  id: data.product_sku_list[i].id,
                  type: 'sku',
                  unit: data.product_sku_list[i].unit,
                  weight: data.product_sku_list[i].weight
                },
                id: this.productTreeIdCounter++,
                isBatch: false
              }

              let productPosition = this.productList.findIndex(item => {
                return item.id === data.product_sku_list[i].id
              })
              let productChecked = false
              if (~productPosition) {
                productChecked = true
              }
              skuList[i].state = { checked: productChecked, checkbox: true }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return skuList
      },
      async blank () {
        return []
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      productStockSetting () {
        return this.$store.getters.productStockSettingSingle
      },
      branchList () {
        return this.$store.getters.branchList
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      productStockSetting () {
        if (this.productStockSetting !== null && this.productStockSetting !== undefined) {
          this.productStockSettingTitle = this.productStockSetting.title

          let branchList = []
          if (typeof this.productStockSetting.branch_list !== 'undefined') {
            for (let i = 0; i < this.productStockSetting.branch_list.length; i++) {
              branchList[branchList.length] = this.productStockSetting.branch_list[i].id
            }
          }

          for (let i = 0; i < this.branches.length; i++) {
            if (~branchList.indexOf(this.branches[i].id)) {
              this.branches[i].checked = true
              this.branchesSelected.push(this.branches[i].title)
            } else {
              this.branches[i].checked = false
            }
          }

          this.productList = this.productStockSetting.product_sku_list.map(item => {
            return {
              id: item.id,
              title: item.title,
              unit: item.unit,
              weight: item.weight
            }
          })

          this.getProductCategory()
            .then((data) => {
              this.productTreeData = data
              this.pageDataReady.products = true
              this.pageDataStatus()
            })
            .catch((e) => {
              console.log(e)
            })
        }
      },
      branchList (val) {
        this.branches = this.branchList
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ProductStockSetting/ProductStockSettingNew.vue